import { getRealPosition, toNode } from "@dhx/ts-common/html";
import { getZIndex } from "@dhx/ts-message";
import {
	Navbar,
	createFactory,
	IMenuElement,
	ContextMode,
	INavbar,
	NavigationBarEvents,
} from "@dhx/ts-navbar";

export class ContextMenu extends Navbar<IMenuElement> implements INavbar {
	protected _isContextMenu = true;

	private _mode: ContextMode;

	showAt(elem: HTMLElement | MouseEvent | TouchEvent | string, showAt: ContextMode = "bottom") {
		if (elem instanceof MouseEvent) {
			this._close(elem as MouseEvent);
			this._changeActivePosition(
				{
					left: window.pageXOffset + elem.x + 1,
					right: window.pageXOffset + elem.x + 1,
					top: window.pageYOffset + elem.y,
					bottom: window.pageYOffset + elem.y,
					zIndex: getZIndex((elem as MouseEvent).currentTarget as HTMLElement),
				},
				showAt
			);
		} else if (window.TouchEvent && elem instanceof TouchEvent) {
			this._close(elem as TouchEvent);
			this._changeActivePosition(
				{
					left: window.pageXOffset + elem.touches[0].clientX,
					right: window.pageXOffset + elem.touches[0].clientX,
					top: window.pageYOffset + elem.touches[0].clientY,
					bottom: window.pageYOffset + elem.touches[0].clientY,
					zIndex: getZIndex((elem as TouchEvent).currentTarget as HTMLElement),
				},
				showAt
			);
		} else if (elem instanceof HTMLElement || typeof elem === "string") {
			const node = toNode(elem);
			this._changeActivePosition(getRealPosition(node), showAt);
		}
	}
	protected _getFactory() {
		return createFactory({
			widget: this as Navbar,
			defaultType: "menuItem",
			allowedTypes: [
				"menuItem",
				"spacer",
				"separator",
				"customHTML",
				// TODO: deprecated
				"customHTMLButton",
			],
			widgetName: "context-menu",
		});
	}
	protected _close(e: MouseEvent | TouchEvent): void {
		this.events.on(NavigationBarEvents.afterHide, () => {
			this._activeMenu = null;
			this._changeActivePosition(null, null);
		});
		super._close(e);
	}
	protected _getMode(_item, _root, active: boolean): ContextMode {
		return active ? this._mode : "right";
	}
	private _changeActivePosition(position, mode: ContextMode) {
		this._activePosition = position;
		this._mode = mode;
		this._listenOuterClick();
		this.paint();
	}
}
